var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sections),function(section){return _c('breakdown',{key:section,attrs:{"id":section,"breakdown":_vm.scoreReport[section],"name":section}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }